import React from 'react';
import { FaMagic } from 'react-icons/fa';
import DebouncedButton from '../Button/Button';
import { t } from '../../i18n/i18n';
import useCreateScreening from '../../hooks/useCreateScreening';

const ButtonModalTestSuggestionAI = () => {

  const { handleSetModalTestSuggestionAI } = useCreateScreening();

  return (
    <div className="d-flex flex-row-reverse p-3">
      <DebouncedButton
        type="primary"
        className="rounded-0 d-flex align-items-center justify-content-center px-3 py-2 text-xs font-weight-600 text-light  "
        onClick={() => handleSetModalTestSuggestionAI(true)}
      >
        <span className="d-flex align-items-center gap-1 text-white">
          {t('CREATE_QUESTION_MODAL_TEXT_BUTTON')} <FaMagic />
        </span>
      </DebouncedButton>
    </div>
  );
};
export default ButtonModalTestSuggestionAI;
